import { NavLink, useLocation } from 'react-router';

interface NavBarMenuItemProps {
  label: string;
  path: string;
}

export const NavBarMenuItem = ({ label, path }: NavBarMenuItemProps) => {
  const { pathname } = useLocation();
  let isBorderOn;
  if (path === '/') {
    isBorderOn = pathname === '/';
  } else {
    isBorderOn = pathname.startsWith(path);
  }

  return (
    <div className="flex flex-row justify-between gap-x-8">
      <NavLink
        to={path}
        className={`${isBorderOn ? 'border-[#5525E5]' : 'border-transparent'} border-b-[3px] pb-[14px] pt-[17px] text-sm font-bold leading-6
          hover:border-[#5525E5]`}
      >
        {label}
      </NavLink>
    </div>
  );
};
